import { Link } from "react-router-dom";
import { AlertTriangle, Phone, ShieldAlert } from "lucide-react";
import { ReportForm } from "@/components/lux/ReportForm";
import { useSeo } from "@/lib/seo";

export default function ReportPage() {
  useSeo({
    title: "Report a concern | LUX",
    description: "Anonymously report a profile, story or interaction on LUX. Reports go straight to our trained moderators.",
    robots: "noindex,follow",
  });
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-testid="report-page">
      <section className="pb-8 pt-14 sm:pt-20">
        <p className="lux-label">Report</p>
        <h1 className="mt-4 font-serif text-5xl leading-[1.02] sm:text-6xl" data-testid="report-title">
          Tell us what you saw.
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-lux-text/80">
          Every report creates a case for our moderators. You don't need an account, you can stay anonymous, and advertisers are never told who reported them.
        </p>
      </section>

      <section className="grid gap-3 sm:grid-cols-2">
        <a
          href="tel:999"
          className="lux-card flex items-start gap-3 p-5 transition-colors hover:border-lux-silver/55"
          data-testid="report-emergency-link"
        >
          <AlertTriangle className="mt-1 h-5 w-5 shrink-0 text-lux-error" aria-hidden="true" />
          <div>
            <p className="font-serif text-xl text-lux-text">Immediate danger: call 999</p>
            <p className="mt-1 text-sm text-lux-muted">UK police, ambulance and fire.</p>
          </div>
        </a>
        <a
          href="tel:08000121700"
          className="lux-card flex items-start gap-3 p-5 transition-colors hover:border-lux-silver/55"
          data-testid="report-helpline-link"
        >
          <Phone className="mt-1 h-5 w-5 shrink-0 text-lux-silver" aria-hidden="true" />
          <div>
            <p className="font-serif text-xl text-lux-silverBright">08000 121 700</p>
            <p className="mt-1 text-sm text-lux-muted">Modern Slavery &amp; Exploitation Helpline, 24/7.</p>
          </div>
        </a>
      </section>

      <section className="mt-10 lux-card p-6 sm:p-8">
        <ReportForm />
      </section>

      <section className="mt-10 flex items-start gap-3 rounded-[12px] border border-lux-border bg-lux-surface2 p-5">
        <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-lux-silver" aria-hidden="true" />
        <p className="text-sm text-lux-muted">
          Reports about a possible minor or coercion go straight to our Compliance team. Learn more in the <Link to="/safety" className="lux-link">safety centre</Link>.
        </p>
      </section>
    </div>
  );
}
